export default __webpack_public_path__ + "static/media/banner-bg-home-previdencia-ir.af663b31.jpg";